<template>
  <section>
    <div class="content_bg">
      <div class="content">
        <Caption label="Front Server" />
        <ul>
          <li>
            <SectionTechItem 
              :image="'tech_icon_aws.png'"
              :record ="{
                text1:'AWS Cloud',
                text2:'AWS Cloud로 가장 저렴하고 강력한 서버를 구축합니다. ',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_nodejs.png'"
              :record ="{
                text1:'Node JS',
                text2:'AWS Cloud lambda와 잘 어울리는 개발 언어 입니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_vue.png'"
              :record ="{
                text1:'Vue',
                text2:'결제와 같은 웹 화면은 Vue 플랫폼으로 개발합니다',
              }"/>
          </li>
          <li>
            <SectionTechItem :image="'tech_icon_mongo.png'"
              :record ="{
                text1:'Mongo DB Cloud',
                text2:'강력한 No SQL DB이며, AWS에 포팅되고 각종 모니터링 기능과 버튼 한번 클릭의 Scale Up을 제공합니다',
              }"/>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>
  
  <script>
import Caption from "./Caption.vue";
import SectionTechItem from "./SectionTechItem.vue";

export default {
  components: {
    Caption,
    SectionTechItem,
  },
  data() {
    return {};
  },
};
</script>
  
<style scoped>
.content_bg {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: fit-content;
  background-color: #ffffff;
  position: relative;
  overflow: hidden;
}

.content {
  display: inline-block;
  text-align: center;
  width: 100vw;
  height: 100%;
  max-width: 1140px;
  padding: 100px 20px 100px 20px;
}

.title_box {
  width: 272px;
}
ul {
  margin-bottom: 80px;
  width: 100%;
  justify-content: space-between;
  list-style-type: none;
  display: flex;
  flex-wrap: wrap;
  padding: 0;
}

ul li {
  margin-top: 50px;
  display: inline-block;
}

.desc {
  font-weight: 300;
  font-size: 24px;
  color: #000000;
}

@media screen and (max-width: 1440px) {
  .content_bg {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: fit-content;
    background-color: #ffffff;
    position: relative;
    overflow: hidden;
  }

  .content {
    display: inline-block;
    text-align: center;
    width: 100vw;
    height: 100%;
    max-width: 1140px;
    padding: 100px 20px 100px 20px;
  }

  .title_box {
    width: 272px;
  }
  ul {
    margin-bottom: 80px;
    width: 100%;
    list-style-type: none;
    display: block;
    text-align: center;
  }

  ul li {
    margin-top: 50px;
    width: fit-content;
    display: block;
    text-align: center;
  }
}
</style>
  